import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { useSearchParams } from "react-router-dom";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { fetchCashReportsData } from "../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  formatDateTime,
} from "../../components/common-data/Converts";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";

const CashReports = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");

  const { cashReportsLoading, cashReportsError, cashReports } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    isActive: "",
    selAddedby:
      !isAdmin && !isManagerRole
        ? {
            label: userInfoData?.name ?? "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    created_by: allFilters.selAddedby?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
    uid: uid || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({
        ...prevs,
        search: allFilters.searchString,
      }));
    }
  };

  function getCashReports(filters) {
    dispatch(
      fetchCashReportsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCashReports(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin && !isClusterManager
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      created_by: allFilters.selAddedby?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (
      !cashReportsLoading &&
      !cashReportsError &&
      cashReports?.status &&
      cashReports?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: cashReports.data,
        pagination:
          cashReports?.pagination?.length > 0 ? cashReports.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [cashReportsLoading, cashReportsError, cashReports]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
                textDecoration: "underline",
              }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "requested amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "created_by",
      text: "created by",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.created_by_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
                textDecoration: "underline",
              }}>
              {row?.created_by_mobile || ""}
              <br />
              {row?.created_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "remarks",
      text: "member remarks",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row.remarks?.length <= 15 ? (
              row.remarks
            ) : row.remarks?.length >= 15 ? (
              <>
                {row.remarks?.substring(0, 15)}
                <b
                  className="link"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "description",
                      rowData: row,
                    }))
                  }>
                  ...Read More
                </b>
              </>
            ) : (
              "NA"
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Cash Discrepancy">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "description" ? "mod-width-50p" : ""
            }`}>
            <ModalHeadAndClose
              title={`${
                modValues.modName === "description"
                  ? modValues.rowData?.user_name || " "
                  : modValues.modName?.replace(/_/g, " ")
              }`}
              onClose={onCloseModal}
            />

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.remarks || "No Content Available"}
                </p>
              </div>
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Cash Discrepancy"}
              isReload={() => {
                getCashReports(filters);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"cash-reports"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={cashReportsLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
              {cashReportsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allData}
                  tableColumns={tbColumns}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CashReports;
